import functions from '../functions';
import { list } from './list';
import pagination from '../components/pagination';
import listResults from '../components/listResults';

$(() => {
    listLocalities.init();
});

const listLocalities = {
    defaults: {
        _page: 1,
        perPage: 12,
        language: functions.getLang(),
        objectGroupId: 10,
    },
    params: {},
    $listItems: null,
    init() {

        this.$listItems = $('.list-items');

        
        if(! this.$listItems[0] || this.defaults.objectGroupId != this.$listItems.attr('data-objectgroupid')) {
            return;
        }

        this.getParams();
        this.find(this.params);

        $(window).on('hashchange', e => {
            this.getParams();
            this.stopChangeEvents = true;

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;
        });

    },
    getParams() {
        this.params = list.getParams(this.params, this.defaults);
    },
    find(params) {
        list.find(params).then((response) => {
            this.findDone(response);
            window.observer.observe();
            //this.initComponents();
        }).fail(error => {
            console.log(error);
        });
    },
    findDone(response) {
        response = JSON.parse(response);          

        list.unsetLoadingMode();

        this.total = response.total;

        this.$listItems.html(response.html);
        if (this.total != 0) {

            if($('.paginate')[0]) {
                $('.paginate').html(pagination({
                    currentPage: this.params._page,
                    total: this.total,
                    perPage: this.params.perPage,
                }));
            }
        }

        listResults.getResults(this.total, this.params._page, this.params.perPage);

        //this.initComponents();

    },
};